import Vue from "vue";
import CloudinaryImage from "@teamnovu/vue-cloudinary-image";

let options = JSON.parse(`{"cloudinaryBaseUrl":"https://res.cloudinary.com/hep-verlag/image/upload/","screenSizes":{"2xs":"200px","xs":"320px","sm":"640px","md":"768px","lg":"1024px","xl":"1280px","2xl":"1600px","3xl":"2000px","4xl":"2500px","5xl":"3000px","6xl":"3500px","7xl":"4000px"}}`);

Vue.use(CloudinaryImage, {
  ...options,
});
